import React, { useCallback, useState } from 'react'
import './App.css'
import MainPage from 'page_main/MainPage'
import { AuthProvider } from 'auth/AuthProvider'
import { HashRouter, Routes, Route } from 'react-router-dom'
import { PAGE_URL_LOGOUT, PAGE_URL_RECEIVE_PAYMENT } from 'SiteURLs'
import { RecoilRoot } from 'recoil'
import PaymentResponseReceiver from 'pay_work/PaymentResponseReceiver'
import SuccessPaymentNotification, {
  IShowPrice,
} from 'page_main/SuccessPaymentNotification'
import { CartProvider } from 'cart/CartProvider'
import Logout from 'auth/Logout'

function App() {
  const [showPrice, setShowPrice] = useState<IShowPrice>({ show: false, price: 0 })

  const onClose = useCallback(() => {
    setShowPrice({ show: false, price: 0 })
  }, [])

  const onShowPayment = useCallback((price, message) => {
    setShowPrice({ show: true, price, message })
  }, [])

  return (
    <RecoilRoot>
      <AuthProvider>
        <CartProvider>
          <HashRouter>
            <SuccessPaymentNotification showPrice={showPrice} onClose={onClose} />

            <Routes>
              <Route
                path={PAGE_URL_RECEIVE_PAYMENT}
                element={<PaymentResponseReceiver onReceivePayment={onShowPayment} />}
              />
              <Route path={PAGE_URL_LOGOUT} element={<Logout />} />

              <Route path={'*'} element={<MainPage />} />
            </Routes>
          </HashRouter>
        </CartProvider>
      </AuthProvider>
    </RecoilRoot>
  )
}

export default App
